import React, { useState, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Breadcrumbs from '../../components/Breadcrumbs';
import Button from '../../components/button';
import UserAvatar from '../../components/UserAvatar';
import NewTableComponent from '../../components/NewTableComponent';
import { FiUsers, FiCalendar, FiDownload, FiPhone, FiMessageSquare, FiMapPin, FiSearch } from 'react-icons/fi';
import { IoMdArrowDropright } from 'react-icons/io';
import { searchIcon } from '../../utils/svgs';
import '../../styles/FMCR.css';
import Select from '../../components/Select';

const initialData = [
  {
    id: 1,
    reportId: "RPT-2825-0129",
    reportTitle: "Weekly Alerts Digest",
    scope: "Available · Past week",
    generatedOn: "2026-05-15",
    assignedDriver: "Noman Aslam",
  },
  {
    id: 2,
    reportId: "RPT-2825-0128",
    reportTitle: "Weekly Fleet Performance — Active Vehicles",
    scope: "All Vehicles - Weekly",
    generatedOn: "2026-03-10",
    assignedDriver: "Waqar Siddiq",
  },
  {
    id: 3,
    reportId: "RPT-2825-0127",
    reportTitle: "Idle Activity Investigation — KHI-9034-F",
    scope: "Active Fleets · Jun 2 - Jun 9",
    generatedOn: "2026-07-01",
    assignedDriver: "Sajid Khan",
  },
  {
    id: 4,
    reportId: "RPT-2825-0126",
    reportTitle: "Alerts Summary — Last 24 Hours",
    scope: "Specific Vehicle · Last 7 days",
    generatedOn: "2026-02-28",
    assignedDriver: "Tariq Ali",
  },
  {
    id: 5,
    reportId: "RPT-2825-0125",
    reportTitle: "Driver Compliance Audit — Q2 Review",
    scope: "Available Vehicles",
    generatedOn: "2026-09-12",
    assignedDriver: "Kamran Akmal",
  },
  {
    id: 6,
    reportId: "RPT-2825-0124",
    reportTitle: "Driver Connectivity Check - All Drivers",
    scope: "Specific Trip",
    generatedOn: "2026-01-20",
    assignedDriver: "Faisal Rauf",
  },
  {
    id: 7,
    reportId: "RPT-2825-0123",
    reportTitle: "Trip Reconciliation — TRP-2024-8841",
    scope: "Specific Duration",
    generatedOn: "2026-06-18",
    assignedDriver: "Irfan Malik",
  },
  {
    id: 8,
    reportId: "RPT-2825-0122",
    reportTitle: "Fuel Consumption Analysis — May 2025",
    scope: "Specific Duration",
    generatedOn: "2026-04-22",
    assignedDriver: "Noman Aslam",
  },
  {
    id: 9,
    reportId: "RPT-2825-0121",
    reportTitle: "Hbo Activity Report",
    scope: "Active Fleets · Jun 2 - Jun 9",
    generatedOn: "2026-06-19",
    assignedDriver: "Waqar Siddiq",
  }
];

const detailMockRows = [
  {
    id: 1,
    vehicle: "KHI-9034-F",
    driver: "Waqar Siddiq",
    trip: "TRP-2024-8841",
    status: "IN QUEUE",
    busEvents: 6,
    totalSize: "2.4 GB",
    latency: "12m",
    events: [
      { id: 1, eventType: "Sudden Braking", timestamp: "2026-05-15 10:14:22", severity: "Critical", details: "Speed dropped from 80 km/h to 30 km/h in 1.2s" },
      { id: 2, eventType: "Over Speeding", timestamp: "2026-05-15 10:25:01", severity: "Warning", details: "Speed reached 115 km/h in a 90 km/h zone" },
      { id: 3, eventType: "Engine Overheat", timestamp: "2026-05-15 10:32:15", severity: "Critical", details: "Coolant temperature exceeded 105°C" },
      { id: 4, eventType: "Rapid Acceleration", timestamp: "2026-05-15 10:48:40", severity: "Warning", details: "Acceleration G-force exceeded threshold" },
      { id: 5, eventType: "Geo-fence Exit", timestamp: "2026-05-15 11:05:12", severity: "Info", details: "Exited Karachi Hub region" },
      { id: 6, eventType: "Idle Timeout", timestamp: "2026-05-15 11:22:30", severity: "Info", details: "Stationary for 15 minutes with engine running" }
    ]
  },
  {
    id: 2,
    vehicle: "LHR-1204-A",
    driver: "Noman Aslam",
    trip: "TRP-2024-8842",
    status: "LOADING",
    busEvents: 6,
    totalSize: "1.8 GB",
    latency: "15m",
    events: [
      { id: 1, eventType: "Door Ajar Alert", timestamp: "2026-05-15 11:45:00", severity: "Warning", details: "Rear compartment door left open during transit" },
      { id: 2, eventType: "Sudden Braking", timestamp: "2026-05-15 11:58:33", severity: "Warning", details: "Speed dropped from 65 km/h to 20 km/h in 1.8s" },
      { id: 3, eventType: "Geo-fence Entry", timestamp: "2026-05-15 12:10:05", severity: "Info", details: "Entered Lahore Industrial Area" },
      { id: 4, eventType: "Route Deviation", timestamp: "2026-05-15 12:22:15", severity: "Critical", details: "Deviated from planned M-2 route by 5.4 km" },
      { id: 5, eventType: "Harsh Cornering", timestamp: "2026-05-15 12:35:40", severity: "Warning", details: "Lateral acceleration exceeded limit at exit loop" },
      { id: 6, eventType: "Over Speeding", timestamp: "2026-05-15 12:50:11", severity: "Warning", details: "Speed reached 102 km/h (Limit: 90)" }
    ]
  },
  {
    id: 3,
    vehicle: "KHI-5512-D",
    driver: "Sajid Khan",
    trip: "TRP-2024-8843",
    status: "IN TRANSIT",
    busEvents: 4,
    totalSize: "1.2 GB",
    latency: "8m",
    events: [
      { id: 1, eventType: "Seatbelt Unfastened", timestamp: "2026-05-15 08:30:12", severity: "Warning", details: "Driver seatbelt unbuckled while speed was 45 km/h" },
      { id: 2, eventType: "Idle Timeout", timestamp: "2026-05-15 08:52:19", severity: "Info", details: "Stationary for 12 minutes with engine running" },
      { id: 3, eventType: "Geo-fence Exit", timestamp: "2026-05-15 09:15:30", severity: "Info", details: "Exited Hyderabad Depot" },
      { id: 4, eventType: "Sudden Braking", timestamp: "2026-05-15 09:44:55", severity: "Warning", details: "Speed dropped from 70 km/h to 35 km/h in 1.5s" }
    ]
  },
  {
    id: 4,
    vehicle: "ISL-7788-G",
    driver: "Tariq Ali",
    trip: "TRP-2024-8844",
    status: "IN QUEUE",
    busEvents: 8,
    totalSize: "3.1 GB",
    latency: "20m",
    events: [
      { id: 1, eventType: "Low Fuel Warning", timestamp: "2026-05-15 13:05:00", severity: "Warning", details: "Fuel level dropped below 15% (Remaining range: ~60km)" },
      { id: 2, eventType: "Sudden Braking", timestamp: "2026-05-15 13:22:12", severity: "Critical", details: "Speed dropped from 95 km/h to 10 km/h in 2.1s" },
      { id: 3, eventType: "Over Speeding", timestamp: "2026-05-15 13:40:55", severity: "Warning", details: "Speed reached 118 km/h in a 90 km/h zone" },
      { id: 4, eventType: "Harsh Cornering", timestamp: "2026-05-15 14:02:18", severity: "Warning", details: "Lateral acceleration exceeded limit" },
      { id: 5, eventType: "Engine Misfire Alert", timestamp: "2026-05-15 14:15:30", severity: "Critical", details: "Cylinder 3 misfire detected (Check engine light ON)" },
      { id: 6, eventType: "Geo-fence Entry", timestamp: "2026-05-15 14:28:44", severity: "Info", details: "Entered Islamabad City Zone" },
      { id: 7, eventType: "Idle Timeout", timestamp: "2026-05-15 14:45:10", severity: "Info", details: "Stationary for 20 minutes with engine running" },
      { id: 8, eventType: "Rapid Acceleration", timestamp: "2026-05-15 15:02:01", severity: "Warning", details: "Acceleration G-force exceeded threshold" }
    ]
  }
];

const ExpandableEventsTable = ({ data }) => {
  if (!data?.events || data.events.length === 0) {
    return (
      <div style={{ padding: '20px 24px', backgroundColor: '#fff', borderTop: '1px solid #E2E8F0' }}>
        <span style={{ fontSize: '14px', color: '#64748B' }}>No events recorded for this vehicle.</span>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px 24px', backgroundColor: '#fff', borderTop: '1px solid #E2E8F0' }} onClick={(e) => e.stopPropagation()}>
      <h5 style={{ fontSize: '16px', fontWeight: 600, color: '#1E293B', marginBottom: '16px', fontFamily: 'Raleway' }}>Bus Events Details</h5>
      <div style={{ border: '1px solid #E2E8F0', borderRadius: '8px', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead style={{ backgroundColor: '#F8FAFC' }}>
            <tr>
              <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '12px', fontWeight: 600, color: '#64748B', textTransform: 'uppercase', fontFamily: 'Raleway' }}>Event Type</th>
              <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '12px', fontWeight: 600, color: '#64748B', textTransform: 'uppercase', fontFamily: 'Raleway' }}>Timestamp</th>
              <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '12px', fontWeight: 600, color: '#64748B', textTransform: 'uppercase', fontFamily: 'Raleway' }}>Severity</th>
              <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '12px', fontWeight: 600, color: '#64748B', textTransform: 'uppercase', fontFamily: 'Raleway' }}>Details</th>
            </tr>
          </thead>
          <tbody>
            {data.events.map((event, index) => {
              const severityColor = event.severity === "Critical" ? "#EF4444" : event.severity === "Warning" ? "#F59E0B" : "#10B981";
              return (
                <tr key={event.id} style={{ borderTop: index > 0 ? '1px solid #E2E8F0' : 'none' }}>
                  <td style={{ padding: '12px 16px', fontSize: '14px', color: '#1E293B', fontWeight: 500 }}>{event.eventType}</td>
                  <td style={{ padding: '12px 16px', fontSize: '14px', color: '#64748B' }}>{event.timestamp}</td>
                  <td style={{ padding: '12px 16px', fontSize: '14px' }}>
                    <span style={{
                      display: 'inline-block',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      fontWeight: 600,
                      backgroundColor: event.severity === "Critical" ? "#FEE2E2" : event.severity === "Warning" ? "#FEF3C7" : "#D1FAE5",
                      color: severityColor
                    }}>
                      {event.severity}
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px', fontSize: '14px', color: '#334155' }}>{event.details}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const ReportDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [searchFilters, setSearchFilters] = useState(null);
  const [detailStatusFilter, setDetailStatusFilter] = useState({ label: "All Statuses", value: "All" });

  const statusSelectOptions = [
    { label: "All Statuses", value: "All" },
    { label: "In Queue", value: "IN QUEUE" },
    { label: "Loading", value: "LOADING" },
    { label: "In Transit", value: "IN TRANSIT" },
  ];



  // Load report from localStorage or initialData fallback
  const report = useMemo(() => {
    const saved = localStorage.getItem('fmcr_reports');
    const reportsList = saved ? JSON.parse(saved) : initialData;
    return reportsList.find(r => r.reportId === id) || {
      reportId: id,
      reportTitle: "Hbo Activity Report",
      scope: "Active Fleets · Jun 2 - Jun 9",
      generatedOn: new Date().toISOString().split('T')[0],
      assignedDriver: "Waqar Siddiq"
    };
  }, [id]);

  const filteredDetailRows = useMemo(() => {
    let result = [...detailMockRows];

    // 1. Search text filtering
    if (searchText) {
      const query = searchText.toLowerCase();
      result = result.filter(
        (row) =>
          (row.vehicle || "").toLowerCase().includes(query) ||
          (row.driver || "").toLowerCase().includes(query) ||
          (row.trip || "").toLowerCase().includes(query)
      );
    }

    // 2. Column filters
    if (searchFilters) {
      Object.keys(searchFilters).forEach((key) => {
        const filter = searchFilters[key];
        if (!filter || filter.value === undefined || filter.value === null || filter.value === "") return;

        const val = String(filter.value).toLowerCase();
        const type = filter.filter_type;

        let propName = "";
        if (key === "vehicleFilter") propName = "vehicle";
        else if (key === "driverFilter") propName = "driver";
        else if (key === "tripFilter") propName = "trip";
        else if (key === "statusFilter") propName = "status";
        else if (key === "busEventsFilter") propName = "busEvents";
        else if (key === "totalSizeFilter") propName = "totalSize";
        else if (key === "latencyFilter") propName = "latency";

        if (propName) {
          result = result.filter((row) => {
            const rowVal = String(row[propName] || "").toLowerCase();
            if (type === "equals" || type === "one_of") return rowVal === val;
            if (type === "contains") return rowVal.includes(val);
            if (type === "starts_with") return rowVal.startsWith(val);
            if (type === "ends_with") return rowVal.endsWith(val);
            return true;
          });
        }
      });
    }

    // 3. Status select filtering
    if (detailStatusFilter && detailStatusFilter.value !== "All") {
      result = result.filter(row => row.status === detailStatusFilter.value);
    }

    return result;
  }, [searchText, searchFilters, detailStatusFilter]);

  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * limit;
    return filteredDetailRows.slice(start, start + limit);
  }, [filteredDetailRows, currentPage, limit]);

  const columns = useMemo(() => [
    {
      name: "Single",
      selector: (row) => row.vehicle,
      cell: (row) => (
        <span className="rfq_link">{row.vehicle}</span>
      ),
      sortable: false,
      tableColumn: true,
      filterName: "vehicleFilter",
      type: "text",
      minWidth: "140px",
    },
    {
      name: "Series",
      selector: (row) => row.driver,
      cell: (row) => (
        <div className="asset_driver_cell">
          <UserAvatar username={row.driver} marginRight="0px" />
          <span className="asset_driver_name">{row.driver || "-"}</span>
        </div>
      ),
      sortable: false,
      tableColumn: true,
      filterName: "driverFilter",
      type: "text",
      minWidth: "220px",
    },
    {
      name: "Trip",
      selector: (row) => row.trip,
      cell: (row) => (
        <span style={{ color: '#4b5563' }}>{row.trip}</span>
      ),
      sortable: false,
      tableColumn: true,
      filterName: "tripFilter",
      type: "text",
      minWidth: "160px",
    },
    {
      name: "Trip Status",
      selector: (row) => row.status,
      cell: (row) => (
        <span className={`chip_status_badge ${row.status.toLowerCase().replace(" ", "_")}`}>
          {row.status}
        </span>
      ),
      sortable: false,
      tableColumn: true,
      filterName: "statusFilter",
      type: "select",
      options: [
        { label: "In Queue", value: "IN QUEUE" },
        { label: "Loading", value: "LOADING" },
        { label: "In Transit", value: "IN TRANSIT" },
      ],
      minWidth: "150px",
    },
    {
      name: "Bus Events",
      selector: (row) => row.busEvents,
      cell: (row) => (
        <span style={{ fontWeight: 600 }}>{row.busEvents}</span>
      ),
      sortable: false,
      tableColumn: true,
      filterName: "busEventsFilter",
      type: "number",
      minWidth: "120px",
    },
    {
      name: "Total Size",
      selector: (row) => row.totalSize,
      cell: (row) => (
        <span style={{ color: '#4b5563' }}>{row.totalSize}</span>
      ),
      sortable: false,
      tableColumn: true,
      filterName: "totalSizeFilter",
      type: "text",
      minWidth: "130px",
    },
    {
      name: "Latency",
      selector: (row) => row.latency,
      cell: (row) => (
        <span style={{ color: '#4b5563' }}>{row.latency}</span>
      ),
      sortable: false,
      tableColumn: true,
      filterName: "latencyFilter",
      type: "text",
      minWidth: "120px",
    },
    {
      name: "Action",
      selector: (row) => row.id,
      cell: (row) => (
        <div className="table_row_actions">
          <button className="icon_action_btn" onClick={(e) => { e.stopPropagation(); alert(`Locating ${row.vehicle}...`); }} title="Locate Vehicle">
            <FiMapPin />
          </button>
        </div>
      ),
      sortable: false,
      tableColumn: false,
      minWidth: "100px",
      grow: 0,
    }
  ], []);

  return (
    <div className="fmcr_page">
      <Breadcrumbs values={["FMCR", "FMCR Reports", report.reportId]} />

      <div className="access_view">
        <div className="d-flex align-items-center gap-3">
          <h2>FMCR</h2>

          <div className="access_btn">
            <button
              className=""
              onClick={() => navigate("/fmcr", { state: { activeView: "tracking" } })}
            >
              Tracking
            </button>
            <button
              className="active"
              onClick={() => navigate("/fmcr")}
            >
              Reports
            </button>
          </div>
        </div>

        <div className="d-flex align-items-center gap-2">
          <Button
            cancelBtn={() => navigate("/fmcr")}
            cancelBtnText="Back to Reports"
            shouldRow={false}
            isShowCancel={true}
            isShowSubmitBtn={false}
          />
        </div>
      </div>

      <div className="mt-4" style={{ paddingLeft: '25px', paddingRight: '25px', paddingBottom: '25px' }}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h3 style={{ fontFamily: 'Raleway', fontWeight: 700, color: '#3d3f5c', margin: 0 }}>
              {report.reportTitle}
            </h3>
            <div className="report_details_meta_row">
              <span style={{ fontWeight: 600, color: '#1447b1' }}>{report.reportId}</span>
              <span className="report_details_affected_badge">
                {report.reportTitle === "Hbo Activity Report" ? "2 vehicles affected" : "1 vehicle affected"}
              </span>
              <span className="report_details_filter_summary">
                Scope: {report.scope}
              </span>
              <span className="report_details_group_filter">Grouped by: Single</span>
            </div>
          </div>
        </div>

        <div className="kpi_grid_row">
          <div className="kpi_card_item">
            <div className="kpi_card_info">
              <h6>Drills in File</h6>
              <h3>5</h3>
            </div>
            <div className="kpi_card_icon" style={{ color: '#2f0f88', fontSize: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FiUsers />
            </div>
          </div>
          <div className="kpi_card_item">
            <div className="kpi_card_info">
              <h6>Bus Events</h6>
              <h3>12</h3>
            </div>
            <div className="kpi_card_icon" style={{ color: '#b26800', fontSize: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FiUsers />
            </div>
          </div>
          <div className="kpi_card_item">
            <div className="kpi_card_info">
              <h6>Total Full Duration</h6>
              <h3>02:14:55</h3>
            </div>
            <div className="kpi_card_icon" style={{ color: '#299900', fontSize: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FiCalendar />
            </div>
          </div>
          <div className="kpi_card_item">
            <div className="kpi_card_info">
              <h6>Largest Single Episode</h6>
              <h3>01:05:12</h3>
            </div>
            <div className="kpi_card_icon" style={{ color: '#1d4ed8', fontSize: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FiCalendar />
            </div>
          </div>
        </div>

        <div className="report_detail_table_wrapper">
          <div className="report_details_table_header">
            <div className="report_details_header_left">
              <div className="report_details_search_box">
                {searchIcon}
                <input
                  type="text"
                  placeholder="Search"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>
              <div className="report_details_select_box">
                <Select
                  placeholder="Filter by Status"
                  options={statusSelectOptions}
                  value={detailStatusFilter}
                  onChange={(val) => {
                    setDetailStatusFilter(val || { label: "All Statuses", value: "All" });
                    setCurrentPage(1);
                  }}
                  isSearch={false}
                  isClearable={false}
                  required={false}
                  customStyles={{ marginBottom: 0 }}
                />
              </div>
            </div>

            <div className="report_details_header_right">
              <button className="export_button_pill excel" onClick={() => alert("Exporting detailed report to Excel...")}>
                <FiDownload /> Excel
              </button>
              <button className="export_button_pill pdf" onClick={() => alert("Exporting detailed report to PDF...")}>
                <FiDownload /> PDF
              </button>
            </div>
          </div>

          <NewTableComponent
            columns={columns}
            data={paginatedData}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            limit={limit}
            setLimit={setLimit}
            totalItems={filteredDetailRows.length}
            totalPages={Math.ceil(filteredDetailRows.length / limit) || 1}
            loading={false}
            showFilter={true}
            setSearchFilters={setSearchFilters}
            searchFilters={searchFilters}
            expandableRows={true}
            expandableRowsComponent={ExpandableEventsTable}
            expandableRowDisabled={row => !row.events || row.events.length === 0}
            expandableIcon={{
              collapsed: <IoMdArrowDropright />,
              expanded: <IoMdArrowDropright style={{ transform: 'rotate(90deg)' }} />
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ReportDetails;
